module.exports = __webpack_public_path__ + "static/media/danos_new.3dfa6088.jpg";